/**
 * The readable message from a rejected `request()` call. The API answers with
 * either `{ error: { code, message } }` or `{ error: 'text' }`; network
 * failures carry `message`.
 */
export const apiErrorMessage = (err, fallback) => {
  if (err && err.error && typeof err.error === 'object' && err.error.message) return err.error.message;
  if (err && typeof err.error === 'string' && err.error) return err.error;
  if (err && typeof err.message === 'string' && err.message) return err.message;
  return fallback;
};
